export default {
  path: 'temporary-regulations/item-execution',
  name: 'TemporaryRegulationsItemExecution',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ItemExecutionIndex.vue')
}
